import { render, staticRenderFns } from "./PropertyOwnerComponent.vue?vue&type=template&id=45f86514"
import script from "./PropertyOwnerComponent.vue?vue&type=script&lang=js"
export * from "./PropertyOwnerComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports